import { render, staticRenderFns } from "./attach-policy.vue?vue&type=template&id=a794ca38&scoped=true&"
import script from "./attach-policy.vue?vue&type=script&lang=js&"
export * from "./attach-policy.vue?vue&type=script&lang=js&"
import style0 from "./attach-policy.vue?vue&type=style&index=0&id=a794ca38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a794ca38",
  null
  
)

export default component.exports